import { Link } from "react-router-dom";
import { Crown, AlertTriangle } from "lucide-react";
import { useMeta } from "../../lib/api";

export default function PlanStatus({ user }) {
  const free = useMeta()?.free_mode;
  const exp = user.plan_expires_at ? new Date(user.plan_expires_at) : null;
  if (free) {
    return (
      <div className="rounded-xl bg-green-50 border border-green-200 p-4 flex items-center gap-3" data-testid="plan-status-active">
        <Crown className="w-6 h-6 text-green-600 shrink-0" />
        <p className="text-sm font-semibold text-green-800">सध्या 99Bazaar मोफत आहे - जाहिराती व संपर्क सर्व सुरू</p>
      </div>
    );
  }
  if (user.plan_state === "active") {
    const days = Math.max(0, Math.ceil((exp - Date.now()) / 86400000));
    return (
      <div className="rounded-xl bg-green-50 border border-green-200 p-4 flex items-center gap-3" data-testid="plan-status-active">
        <Crown className="w-6 h-6 text-green-600 shrink-0" />
        <div className="text-sm">
          <p className="font-semibold text-green-800">{user.plan_id === "trial" ? "Free Trial" : "Membership"} सुरू आहे · {days} दिवस बाकी</p>
          <p className="text-green-700">Valid till {exp.toLocaleDateString("en-IN")}</p>
        </div>
      </div>
    );
  }
  return (
    <div className="rounded-xl bg-red-50 border border-red-200 p-4 flex items-center gap-3" data-testid="plan-status-expired">
      <AlertTriangle className="w-6 h-6 text-[var(--sell)] shrink-0" />
      <div className="text-sm flex-1">
        <p className="font-semibold text-[var(--sell)]" data-testid="plan-expired-message">{user.plan_state === "none" ? "Membership नाही - Plan निवडा" : "प्लॅन संपला - पुन्हा सुरू करा"}</p>
        <p className="text-slate-600">तुमच्या जाहिराती लपवल्या आहेत, संपर्क बंद आहे.</p>
      </div>
      <Link to="/plans" className="h-10 px-4 rounded-lg bg-[var(--orange)] text-white font-semibold flex items-center" data-testid="plan-renew-button">Renew</Link>
    </div>
  );
}
